import { render } from "./DetailsModal.vue?vue&type=template&id=4b5c54bf&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"

import "./DetailsModal.vue?vue&type=style&index=0&id=4b5c54bf&scoped=true&lang=css"
import "./DetailsModal.vue?vue&type=style&index=1&id=4b5c54bf&lang=scss&scoped=true"

import exportComponent from "/Users/n0m4dz/workspace/projects/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5c54bf"]])

export default __exports__